import { render, staticRenderFns } from "./PromotionEnd.vue?vue&type=template&id=0b5b0c15"
import script from "./PromotionEnd.vue?vue&type=script&lang=js"
export * from "./PromotionEnd.vue?vue&type=script&lang=js"
import style0 from "./PromotionEnd.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports